import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73494ac9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id", "name", "required"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "switch" }
const _hoisted_7 = ["id", "name", "required"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_9 = ["id", "required"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "m-questionnaire-redeemed"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token = _resolveComponent("m-token")!

  return (_ctx.state.activeEligibleToken)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        class: "m-questionnaire-redeem",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitQuestionnaire && _ctx.submitQuestionnaire(...args)), ["prevent"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.questions, (question, idx) => {
          return (_openBlock(), _createElementBlock("div", { key: idx }, [
            _createElementVNode("label", {
              for: question.id.toString()
            }, _toDisplayString(question.text) + " " + _toDisplayString(question.required ? '(required)' : ''), 9, _hoisted_1),
            (question.type == 6 || question.type == 8)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("select", {
                    id: question.id.toString(),
                    name: question.id.toString(),
                    required: question.required
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (option, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: option
                      }, _toDisplayString(option), 9, _hoisted_4))
                    }), 128))
                  ], 8, _hoisted_3)
                ]))
              : (question.type == 7)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, [
                      _createElementVNode("input", {
                        id: question.id.toString(),
                        type: "checkbox",
                        name: question.id.toString(),
                        required: question.required
                      }, null, 8, _hoisted_7),
                      _hoisted_8
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("input", {
                    key: 2,
                    id: question.id,
                    type: "text",
                    maxlength: "256",
                    name: "question.id",
                    required: question.required
                  }, null, 8, _hoisted_9))
          ]))
        }), 128)),
        _createElementVNode("input", {
          type: "submit",
          value: "Submit",
          disabled: _ctx.isSubmittingRedemption
        }, null, 8, _hoisted_10)
      ], 32))
    : (_ctx.state.activeRedemption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_m_token, { token: _ctx.redemptionToToken }, null, 8, ["token"]),
          _createElementVNode("table", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redemptionToToken.submissions, (question, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(question.questionText), 1),
                (_ctx.questionTypeForSubmission(question.questionId) == 8)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicPollQuestionResults, (poll, pollIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: pollIndex }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(poll, (result, quest) => {
                            return (_openBlock(), _createElementBlock("p", { key: quest }, _toDisplayString(quest) + " : " + _toDisplayString(result), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(question.answer), 1))
              ]))
            }), 128))
          ]),
          (_ctx.getters.campaignIsActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: _ctx.isSubmittingRedemption,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editSubmission && _ctx.editSubmission(...args)))
              }, " Edit ", 8, _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
}